import { render, staticRenderFns } from "./archivesInfo.vue?vue&type=template&id=5adbff1c&scoped=true&"
import script from "./archivesInfo.vue?vue&type=script&lang=js&"
export * from "./archivesInfo.vue?vue&type=script&lang=js&"
import style0 from "./archivesInfo.vue?vue&type=style&index=0&id=5adbff1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adbff1c",
  null
  
)

export default component.exports